<template>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>序号</th>
          <th>姓名</th>
          <th>手机号</th>                    
          <th>会员卡号</th>
          <th>性别</th>
          <th>地址</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in users" :key="index" @click="onRowClick(item)">
          <td>{{index+1}}</td>
          <td>{{item.profile.name}}</td>
          <td>{{item.profile.phone}}</td>
          <td>{{item.profile.vipID}}</td>
          <td>{{item.profile.sex}}</td>
          <td>{{item.profile.address}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
``
<script>
export default {
  props: ['users'],
  methods: {
    onRowClick(item) {
      this.$emit('onRowClick', item)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/list/User.vue